import { render, staticRenderFns } from "./ReportYear.vue?vue&type=template&id=5634a3e5&scoped=true&"
import script from "./ReportYear.vue?vue&type=script&lang=js&"
export * from "./ReportYear.vue?vue&type=script&lang=js&"
import style0 from "./ReportYear.vue?vue&type=style&index=0&id=5634a3e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5634a3e5",
  null
  
)

export default component.exports